module.exports = __webpack_public_path__ + "img/SMW.dd505bd9.png";